// extracted by mini-css-extract-plugin
export default {"panel":"homePanel-module--panel--2LTIB","disabled":"homePanel-module--disabled--3rGIy","toolDescription":"homePanel-module--tool-description--36IKh"};